import { initContract } from "@ts-rest/core";
import { createAddress } from "./commands/index.js";
import { addresses } from "./queries/index.js";

export const contract = initContract().router(
  {
    physicalAddress: {
      lookup: addresses.contract.lookup,
      create: createAddress.contract.create,
    },
  },
  {
    strictStatusCodes: true,
  },
);
